// extracted by mini-css-extract-plugin
module.exports = {"trustedBy":"ob_CsBrXP","title":"ob_foHoYK","trustedByItems":"ob_y140Js","orgName":"ob_zH8AXm","viewAllBtn":"ob_YkstxE","arrowIcon":"ob_zhZx9X","viewAllBtnText":"ob_cr0F7s"};